import styled from "@emotion/styled";
import theme from "@theme";
import InnoIcons from "InnoUI/innoicons";

const DrawerTitlesContainer = styled.div`
  display: flex;
  background: ${theme.gradient.themeGradient};
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px 0px 20px;
  height: 50px;
  position: sticky;
  top: 0;
  z-index: 1000;
`;

const CloseIcon = styled.p`
  cursor: pointer;
  color: white;
`;

const DrawerTitles = styled.span`
  font-size: 17px;
  color: white;
  font-weight: normal;
`;

const InputContiner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 250px;
  margin-bottom: 10px;
`;

const SearchIcon = styled(InnoIcons.SearchIcon)`
  position: absolute;
  left: 10px;
  color: #888;
  font-size: 20px;
`;

const InputStyle = styled.input`
  width: 100%;
  padding: 8px 8px 8px 35px;
  font-size: 13px;
  border: 1px solid #ccc;
  border-radius: 3px;
  &:focus {
    outline: none;
    border-color: #ccc;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 30px 20px 0px 20px;
`;

const SC = {
  DrawerTitlesContainer,
  CloseIcon,
  DrawerTitles,
  InputContiner,
  SearchIcon,
  InputStyle,
  ButtonContainer,
};

export default SC;
